import React from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";
import useStyles from "./RadioIcon.styles";
import { FontAwesomeIcon } from "./FontAwesome";

interface Props {
    checked: boolean;
    hover?: boolean;
    disabled?: boolean;
    backgroundLess?: boolean;
}

export function RadioIcon({ checked, disabled, hover, backgroundLess }: Props) {
    const theme: any = useTheme();
    const classes = useStyles({ theme });
    const { PrimaryColor, ControlBorderColor } = theme;
    const selectedColor = disabled ? ControlBorderColor : PrimaryColor;
    let borderColor = ControlBorderColor;
    const backgroundless = backgroundLess || (theme.ControlAlpha === 0 && theme.BorderWidth === 0);
    if (backgroundless) borderColor = hover || checked ? selectedColor : ControlBorderColor;
    return (
        <span
            className={classnames(
                "fa-layers fa-fw",
                classes.radioIcon,
                checked && classes.radioIconChecked,
                disabled && classes.radioIconDisabled,
            )}
        >
            <FontAwesomeIcon
                icon={["fas", "circle"]}
                style={{
                    transition: "color 200ms",
                    color: borderColor,
                }}
            />
            <FontAwesomeIcon
                icon={["fas", "circle"]}
                color="#fff"
                style={{
                    transition: "transform 200ms",
                    transform: checked && !backgroundless ? "" : "scale(0.8)",
                }}
            />
            <FontAwesomeIcon
                icon={["fas", "circle"]}
                color={selectedColor}
                style={{
                    transition: "opacity 200ms",
                    opacity: checked ? 1 : 0,
                }}
                transform="shrink-10"
            />
        </span>
    );
}
